import Flex from '@deprecated-ui/common/Flex';
import { Select, Input } from '../styled';
import OptionsGroup from './OptionGroup';
import useValueMetrics from './useValuationMetrics';

interface InputMetricsProps {
  disabled?: boolean;
  metrics: 'eps' | 'growth'; // eps | growth
  selectValue: any;
  value: any;
  onChange: (e: any) => void;
  onSelect: (e: any) => void;
}

function InputMetrics({
  disabled,
  metrics: metricsKey,
  selectValue,
  value,
  onChange,
  onSelect,
}: InputMetricsProps) {
  const { metrics, getMetrics } = useValueMetrics();

  const options = metrics?.params?.[metricsKey] || [];

  const onChangeSelection = (e: any) => {
    if (disabled) {
      return;
    }

    onSelect(e);
  };

  return (
    <Flex>
      {metrics.params && (
        <Select
          value={selectValue === 0 ? getMetrics(metricsKey) : selectValue}
          onSelect={onChangeSelection}
          style={{ minWidth: '50px' }}
        >
          {options.map((item) => (
            <OptionsGroup value={item.fitem_id}>{item.fitem_name}</OptionsGroup>
          ))}
        </Select>
      )}
      <Input onChange={onChange} disabled={disabled} value={value} />
    </Flex>
  );
}

export default InputMetrics;
